import { Component, OnInit, ViewChild, ElementRef, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

import { UserListComponent } from '../../list/user-list/user-list.component';

@Component({
    selector: 'sn-user-lookup',
    templateUrl: './user-lookup.component.html',
    styleUrls: ['./user-lookup.component.css']
})
export class UserLookupComponent implements OnInit {
    @Input() lookup_scope: string;
    @ViewChild('userList') userList: ElementRef;

    constructor(
        public activeModal: NgbActiveModal,

    ) { }

    selectedUser: any;

    ngOnInit() {
        var u = this.userList;
        // u["selectEventFunc"] = this.selectEvent;
    }

    onSelect(e) {
        this.selectedUser = e;
        //this.activeModal.close(e);
    }

    confirm() {
        this.activeModal.close(this.selectedUser);
    }

    dismiss() {
        this.activeModal.dismiss();
    }
}



// WEBPACK FOOTER //
// C:/Azure/Source/Workspaces/SalesNOW/SalesSOLO/WebSites/SalesSOLO.Web.Angular.telesales/src/app/components/lookup/user-lookup/user-lookup.component.ts